import { useState, useEffect } from 'react';
import { involvementsService } from '../services/dataService';

/**
 * Custom hook to fetch involvements from Firestore
 * @returns {Object} { involvements, loading, error, refetch }
 */
export const useInvolvements = () => {
  const [involvements, setInvolvements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInvolvements = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await involvementsService.getAll();
      
      if (result.success) {
        // Sort by order field
        const sortedInvolvements = result.data.sort((a, b) => (a.order || 0) - (b.order || 0));
        setInvolvements(sortedInvolvements);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvolvements();
  }, []);

  return {
    involvements,
    loading,
    error,
    refetch: fetchInvolvements
  };
};